import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import IssuedChequeCreateView from 'src/sections/issued-cheque/view/issued-cheque-create-view';

export default function IssuedChequeCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> New Issued Cheque</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_ISSUED_CHEQUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <IssuedChequeCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
